import React, { useState, useRef, useEffect } from 'react'

import usePostImagesUpload from 'hooks/usePostImagesUpload'

import api from 'common/api'
import ImagesUpload from 'components/imagesUpload'

export default function ModalMyInquiry({ btnClose, inquirySeq, handleCloseModal }) {
  const inquiryRef = useRef()
  const { postImagesUpload } = usePostImagesUpload()

  const [isDisabledButton, setIsDisabledButton] = useState(true)
  const [inquiryStatus, setInquiryStatus] = useState(false)
  const [categoryList, setCategoryList] = useState(null)
  const [inquireList, setInquireList] = useState(null)
  const [selectedServiceCategory, setSelectedServiceCategory] = useState(null)
  const [selectInquiryCategory, setSelectInquiryCategory] = useState(null)
  const [textareaValue, setTextareaValue] = useState('')
  const [textareaLength, setTextareaLength] = useState(0)
  const [fileImages, setFileImages] = useState([])

  const handleInquiryValue = (e) => {
    setTextareaValue(e.target.value)
    setTextareaLength(e.target.value.length)
  }

  const handleInputValue = (e) => {
    setSelectInquiryCategory(e.target.value)
  }

  const handleServiceCategory = (e) => {
    setSelectedServiceCategory(e.target.value)
    setSelectInquiryCategory(null)
  }

  // 문의 카테고리 리스트
  const getCategoryList = () => {
    api
      .get(`/v2/inquiry/service/category/list`)
      .then((response) => {
        setCategoryList(response.data.data)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  // 내가 작성한 문의가 있다면 데이터 업데이트
  const getMyInquiry = () => {
    api
      .get(`/v2/inquiry/${inquirySeq}`)
      .then((response) => {
        if (response.data.meta.code === 200) {
          setInquiryStatus(true)
          setTextareaValue(response.data.data.contents)
          setTextareaLength(response.data.data.contents.length)
          setFileImages(response.data.data.attachments)
          setSelectInquiryCategory(response.data.data.category)
          setSelectedServiceCategory(response.data.data.serviceType)
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }

  // 문의 등록
  const postMyInquiry = async () => {
    const attachments = await getAttachment()

    const data = {
      attachments,
      serviceType: selectedServiceCategory,
      category: selectInquiryCategory,
      contents: textareaValue
    }
    api
      .post('/v2/inquiry', data)
      .then((response) => {
        if (response.data.meta.code !== 200) {
          alert(response.data.meta.message)

          return false
        }

        alert('문의가 저장되었습니다.')
        window.location.reload()
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const getAttachment = async () => {
    try {
      if (fileImages.length === 0) {
        return null
      }
      let attachments = fileImages.filter((item) => item.attachmentName)

      if (fileImages.length > 0 || fileImages.filter((item) => !item.attachmentName) > 0) {
        const attachedImages = await postImagesUpload(
          fileImages.filter((item) => !item.attachmentName)
        )
        attachedImages?.map((list) =>
          attachments.push({
            attachmentName: list.saveFileName,
            attachmentPath: list.filePath,
            thumbnailPath: list.thumbnailFile.filePath
          })
        )
      }
      return attachments
    } catch (error) {
      console.error('Error during review submission:', error)
      alert('첨부파일 저장 중 오류가 발생했습니다.')
    } finally {
      setIsDisabledButton(false)
    }
  }

  // 문의 수정
  const editMyInquiry = async () => {
    const attachments = await getAttachment()

    const data = {
      attachments,
      serviceType: selectedServiceCategory,
      category: selectInquiryCategory,
      contents: textareaValue,
      inquirySeq: inquirySeq
    }

    api
      .put('/v2/inquiry', data)
      .then((response) => {
        if (response.data.meta.code !== 200) {
          alert(response.data.meta.message)

          return false
        }

        alert('문의가 수정되었습니다.')
        window.location.reload()
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const handleRegistMyInquiry = () => {
    if (!selectedServiceCategory) {
      alert('서비스 영역을 선택하세요.')

      return false
    }

    if (!selectInquiryCategory) {
      alert('문의 분류를 선택하세요.')

      return false
    }

    if (textareaLength < 11) {
      alert('최소 10자 이상 입력해주세요.')
      inquiryRef.current.focus()

      return false
    }

    try {
      setIsDisabledButton(true)
      // 문의를 작성한 적이 있다면 수정 API, 없다면 등록 API
      if (inquiryStatus) {
        editMyInquiry()
      } else {
        postMyInquiry()
      }
    } catch (error) {
      console.error('Error during review submission:', error)
      alert('리뷰 등록 중 오류가 발생했습니다.')
    } finally {
      setIsDisabledButton(false)
    }
  }

  useEffect(() => {
    if (inquirySeq) {
      getMyInquiry()
    }
    getCategoryList()
  }, [])

  useEffect(() => {
    if (categoryList) {
      setInquireList(categoryList.filter((item) => item.serviceType === selectedServiceCategory)[0])
    }
  }, [selectedServiceCategory])

  useEffect(() => {
    if (selectedServiceCategory && selectInquiryCategory && textareaLength > 10) {
      setIsDisabledButton(false)
    } else {
      setIsDisabledButton(true)
    }
  }, [selectedServiceCategory, selectInquiryCategory, textareaLength])

  return (
    <>
      <div className="modal-wrap">
        <div className="dimmed" onClick={handleCloseModal}></div>
        <div className="modal-inner">
          {btnClose && (
            <button type="button" className="btn-modal-close" onClick={handleCloseModal}>
              <span className="blind">닫기</span>
            </button>
          )}
          <div className="modal-header">
            <strong>1:1 문의</strong>
          </div>
          <div className="modal-content">
            <div className="modal-form-col write-form">
              <form action="frmMyInquiry">
                <dl>
                  <dt className="mark">서비스 선택</dt>
                  <dd>
                    <select
                      className={
                        selectedServiceCategory ? 'modal-select-box active' : 'modal-select-box'
                      }
                      name="category"
                      value={selectedServiceCategory ? selectedServiceCategory : 'default'}
                      onChange={handleServiceCategory}
                    >
                      <option value="default" disabled>
                        서비스 영역을 선택해주세요
                      </option>
                      {categoryList &&
                        categoryList.map((service) => (
                          <option key={service.serviceType} value={service.serviceType}>
                            {service.serviceTypeName}
                          </option>
                        ))}
                    </select>
                  </dd>
                </dl>
                <dl>
                  <dt className="mark">문의분류</dt>
                  <dd>
                    <select
                      className={
                        selectInquiryCategory ? 'modal-select-box active' : 'modal-select-box'
                      }
                      name="category"
                      value={selectInquiryCategory ? selectInquiryCategory : 'default'}
                      onChange={handleInputValue}
                    >
                      <option value="default" disabled>
                        문의 분류를 선택해주세요
                      </option>
                      {inquireList &&
                        inquireList.categoryList.map((list) => (
                          <option key={list.categoryCode} value={list.categoryCode}>
                            {list.categoryName}
                          </option>
                        ))}
                    </select>
                  </dd>
                </dl>
                <dl className="inquiry-area">
                  <dt>문의내용</dt>
                  <dd>
                    <textarea
                      placeholder="※ 현재 문의량이 많아 답변이 지연되고 있습니다. 순차적으로 답변 드리고 있으며, 빠른 답변이 될 수 있도록 하겠습니다. 불편을 드려 죄송합니다."
                      maxLength="2000"
                      ref={inquiryRef}
                      value={textareaValue}
                      onChange={handleInquiryValue}
                    ></textarea>
                    <p>
                      <span>{textareaLength}</span>/2000
                    </p>
                  </dd>
                </dl>
                <ImagesUpload fileImages={fileImages} setFileImages={setFileImages} />
              </form>
              <div className="notice">
                <strong>문의 작성 안내</strong>
                <br />
                <ul>
                  <li>
                    약관 및 법률에 위배(비속어, 허위사실 등), 해석이 불가능하거나 문의 외 다른
                    목적의 글을 작성한 경우 관리자에 의해 사전 동의 없이 미게시 될 수 있습니다.
                  </li>
                  <li>작성하신 내용은 홍보, 이벤트 등 다양한 방법으로 활용될 수 있습니다.</li>
                </ul>
                <div className="btn-flex-form">
                  <button
                    type="button"
                    disabled={isDisabledButton}
                    className={isDisabledButton ? 'btn disabled' : 'btn active'}
                    onClick={handleRegistMyInquiry}
                  >
                    <span>확인</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
